import React from "react"

function EcommerceC() {
  return (
    <svg viewBox="0 0 266 150" fill="none">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={20}
        y={37}
        width={74}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect
        x={20}
        y={112}
        width={26}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect
        x={20}
        y={30}
        width={38}
        height={3}
        rx={1.5}
        fill="var(--base-400)"
      />
      <rect
        x={20}
        y={55}
        width={26}
        height={3}
        rx={1.5}
        fill="var(--main-500)"
      />
      <path
        d="M56 56.5a1.5 1.5 0 011.5-1.5h23a1.5 1.5 0 010 3h-23a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <rect
        x={92}
        y={55}
        width={26}
        height={3}
        rx={1.5}
        fill="var(--base-500)"
      />
      <rect x={20} y={73} width={92} height={4} rx={2} fill="var(--base-500)" />
      <path
        d="M132.5 102a.5.5 0 010 1h-112a.5.5 0 010-1h112zM133 64v2H20v-2h113z"
        fill="var(--base-300)"
      />
      <rect
        x={87}
        y={110}
        width={31}
        height={10}
        rx={2}
        fill="var(--main-500)"
      />
      <rect x={20} y={81} width={82} height={4} rx={2} fill="var(--base-500)" />
      <rect x={20} y={89} width={68} height={4} rx={2} fill="var(--base-500)" />
      <path fill="var(--main-500)" d="M20 64h32v2H20z" />
      <path
        d="M187.792 92h26.544a3.785 3.785 0 003.792-3.778V61.778A3.785 3.785 0 00214.336 58h-26.544A3.785 3.785 0 00184 61.778v26.444A3.785 3.785 0 00187.792 92zm0 0l20.856-20.778 9.48 9.445m-20.856-12.278a2.838 2.838 0 01-2.844 2.833 2.838 2.838 0 01-2.844-2.833 2.838 2.838 0 012.844-2.833 2.838 2.838 0 012.844 2.833z"
        stroke="var(--base-500)"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx={128} cy={114} r={5} fill="var(--base-300)" />
    </svg>
  )
}

export default EcommerceC;
